import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export const SectionHeader = ({ eyebrow, title, lede, kicker }) => (
  <section className="mx-auto max-w-[1440px] px-6 pt-16 lg:px-12 lg:pt-24">
    <Link
      to="/"
      data-testid="back-home"
      className="group inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.24em] text-[#EDE4D3]/55 transition-colors hover:text-[#D4A574]"
    >
      <ArrowLeft className="h-3.5 w-3.5 transition-transform group-hover:-translate-x-1" />
      Back to portfolio
    </Link>

    <div className="mt-10 grid gap-10 lg:grid-cols-[1fr,1.4fr] lg:gap-20">
      <div>
        {eyebrow && (
          <p className="text-[11px] uppercase tracking-[0.3em] text-[#D4A574]">
            {eyebrow}
          </p>
        )}
        <h1 className="mt-4 font-serif text-4xl leading-[1.02] tracking-tight sm:text-5xl lg:text-[64px]">
          {title}
        </h1>
      </div>
      <div className="lg:pt-6">
        {kicker && (
          <p className="font-serif text-xl italic leading-snug text-[#EDE4D3]/80 lg:text-2xl">
            {kicker}
          </p>
        )}
        {lede && (
          <p className="mt-6 max-w-[62ch] text-[15px] leading-relaxed text-[#EDE4D3]/65">
            {lede}
          </p>
        )}
      </div>
    </div>

    <div className="mt-16 h-px w-full bg-[#EDE4D3]/12" />
  </section>
);

export default SectionHeader;
